import * as React from 'react'

import Svg, {
  ClipPath,
  Defs,
  G,
  LinearGradient,
  Path,
  Stop,
} from 'react-native-svg'

const CalenderExpiredFilled = (props) => (
  <Svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <G clipPath="url(#a)">
      <Path
        fill="url(#b)"
        d="M14.733 4.425h-.65V3.25a.747.747 0 0 0-.75-.75.747.747 0 0 0-.75.75v1.175H7.417V3.25a.747.747 0 0 0-.75-.75.747.747 0 0 0-.75.75v1.175h-.625a2.77 2.77 0 0 0-2.767 2.767v.283h14.983v-.283a2.77 2.77 0 0 0-2.766-2.767h-.009Z"
      />
      <Path
        fill="url(#c)"
        d="M2.517 14.708a2.77 2.77 0 0 0 2.766 2.767h9.442a2.77 2.77 0 0 0 2.767-2.767V8.8H2.517v5.908Zm8.191-4.316-.15 3.25H9.433l-.15-3.25h1.425Zm-.716 3.766c.416 0 .733.317.733.734a.719.719 0 0 1-.733.733.719.719 0 0 1-.734-.733c0-.417.317-.734.734-.734Z"
      />
    </G>
    <Defs>
      <LinearGradient
        id="b"
        x1={10.017}
        x2={10.017}
        y1={2.5}
        y2={7.475}
        gradientUnits="userSpaceOnUse"
      >
        <Stop stopColor="#FF9C9C" />
        <Stop offset={1} stopColor="#DE6D6D" />
      </LinearGradient>
      <LinearGradient
        id="c"
        x1={10.004}
        x2={10.004}
        y1={8.8}
        y2={17.475}
        gradientUnits="userSpaceOnUse"
      >
        <Stop stopColor="#FF9C9C" />
        <Stop offset={1} stopColor="#DE6D6D" />
      </LinearGradient>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h20v20H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)
export default CalenderExpiredFilled
